import React from 'react';
import Button, { CustomButtonProps } from '../../../Button/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import OutlinedSecondaryButton from '../../../Button/OutlinedSecondaryButton';

const useStyles = makeStyles((theme: any) => ({
  button: {
    padding: `${theme.spacing(1.25)}px ${theme.spacing(4)}px`,
    borderRadius: theme.spacing(1.5),
    fontSize: 20,
    lineHeight: 1.25,
    '& .MuiButton-label': {
      fontSize: 20,
    },
  },
  actionButton: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  cancelButton: {
    marginLeft: theme.spacing(2),
  },
  container: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: theme.spacing(5),
  },
}));

interface ButtonProps {
  label: string;
  action?: (...args) => void;
  className?: string;
  buttonProps?: CustomButtonProps;
}

export interface ConfirmOrCancelButtonsProps {
  confirm?: ButtonProps;
  cancel?: ButtonProps;
}

const noopFunc = () => {};

export default function ConfirmOrCancelButtons({
  confirm,
  cancel,
}: ConfirmOrCancelButtonsProps) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {confirm && (
        <Button
          variant="contained"
          color="primary"
          onClick={confirm.action ?? noopFunc}
          className={`${classes.button} ${classes.actionButton} ${
            confirm.className ?? ''
          }`}
          {...confirm.buttonProps}
        >
          {confirm.label}
        </Button>
      )}
      {cancel && (
        <OutlinedSecondaryButton
          onClick={cancel.action ?? noopFunc}
          className={`${classes.button} ${classes.cancelButton} ${
            cancel.className ?? ''
          }`}
          {...cancel.buttonProps}
        >
          {cancel.label}
        </OutlinedSecondaryButton>
      )}
    </div>
  );
}
